<template>
  <div>
    <el-drawer
      :visible.sync="relateNoVisible"
      title="原材料管理"
      direction="rtl"
      size="70%"
      :modal-append-to-body="false"
      :before-close="handleClose"
    >
      <div class="content-wrapper">
        <e-search
          class="margin-b20"
          :data="filterInfo.data"
          :field-list="filterInfo.fieldList"
          :width="filterInfo.width"
          @handleFilter="handleFilter"
          @handleReset="handleReset"
        ></e-search>
        <div style="height: 540px">
          <div class="flex table-wrapper">
            <div style="width: 55%">
              <div class="tip-title margin-b10">待关联订单</div>
              <tableList
                ref="multipleTable"
                maxHeight="460"
                rowKey="orderNo"
                :loading="false"
                :indexShow="indexShow"
                :selectionShow="selectionShow"
                :table-data="tableData"
                :table-label="tableLabel"
                @handleSelect="handleSelect"
                @handleSelectAll="handleSelectAll"
                :checkSelectable="checkboxSelect"
              >
                <template #orderSource="slot">
                  <div class="flex-all-center">
                    {{ formatOrderSource(slot.scope.row.orderSource) }}
                  </div>
                </template>
              </tableList>
              <el-pagination
                class="margin-t10 flex-r"
                small
                layout="prev, pager, next"
                :total="searchData.total"
                :current-page="searchData.pageNum"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
            <div class="flex-all-center add-box">
              <eui-btn
                type="weak"
                @click="handleAddData"
                :disabled="selectData.length === 0"
                >添加</eui-btn
              >
            </div>
            <div class="right-table" style="width: 35%">
              <div class="tip-title flex-sb">
                <div>已关联订单</div>
                <eui-btn
                  type="text"
                  color="#F0250F "
                  :disabled="addSelectData.length === 0"
                  @click="handleClearAll"
                  >全部清除
                </eui-btn>
              </div>
              <tableList
                rowKey="id"
                :loading="false"
                maxHeight="460"
                :table-data="addSelectData"
                :table-label="addSelectDataLabel"
              >
                <template #orderNo>
                  <div class="flex-all-center">
                    当前选择：{{ addSelectData.length }}
                  </div>
                </template>
                <!-- <template #orderSource="slot">
                  <div class="flex-all-center">
                    {{ formatOrderSource(slot.scope.row.orderSource) }}
                  </div>
                </template> -->
                <template v-slot:operate="slot">
                  <eui-btn
                    type="text"
                    color="#F0250F "
                    @click="handleDel(slot.scope.$index, slot.scope.row)"
                    >删除
                  </eui-btn>
                </template>
              </tableList>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-all-center drawer-footer">
        <eui-btn
          type="secondary"
          style="margin-right: 30px"
          @click="handleCancle"
          >取消</eui-btn
        >
        <eui-btn type="primary" @click="handleConfirm">确定</eui-btn>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import tableList from '../../../components/common/e-table-list.vue';
import api from '../../../api/order';
import eSearch from '@/modules/projectA/components/common/e-search';

export default {
  name: 'relateNoDialog',
  components: {
    tableList,
    eSearch,
  },
  props: {
    relateNoVisible: Boolean,
    relateNoData: Object,
  },
  data() {
    return {
      filterInfo: {
        width: {
          labelWidth: 110,
          itemWidth: 200,
        },
        data: {
          orderNo: null,
          supplierCompany: null,
          submitTime: null,
        },
        fieldList: [
          { label: '原材料订单编号', type: 'input', value: 'orderNo' },
          {
            label: '供应商名称',
            type: 'input',
            value: 'supplierCompany',
            placeholder: '请输入供应商名称',
          },
          {
            label: '下单时间',
            type: 'date',
            value: 'submitTime',
            defaultTime: ['00:00:00', '23:59:59'],
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            dateType: 'daterange',
            clearable: false,
          },
        ],
      },
      type: 0,
      id: null,
      ecPurchasePlanIdList: [],
      purchasePlanId: null,
      selectionShow: true,
      indexShow: true,
      tableData: [],
      tableLabel: [
        {
          label: '原材料订单编号',
          param: 'orderNo',
          align: 'left',
          width: '180',
        },
        { label: '订单状态', param: 'orderStatus', align: 'center' },
        {
          label: '订单类型',
          param: 'orderSource',
          align: 'left',
          slot: 'orderSource',
        },
        {
          label: '供应商名称',
          param: 'supplierCompany',
          align: 'left',
          tooltip: true,
        },
        { label: '下单时间', param: 'submitTime', align: 'left' },
      ],
      selectData: [], //左侧选中的数据
      addSelectData: [], //右侧添加的table数据
      addSelectDataLabel: [
        {
          label: '当前选择',
          width: '160',
          align: 'center',
          param: 'orderNo',
          headerSlot: 'orderNo',
        },
        // {
        //   label: '订单类型',
        //   param: 'orderSource',
        //   align: 'left',
        //   slot: 'orderSource',
        // },
        {
          label: '供应商名称',
          param: 'supplierCompany',
          align: 'center',
          tooltip: true,
        },
        {
          label: '操作',
          param: '',
          align: 'center',
          slot: 'operate',
          fixed: 'right',
          width: '80',
        },
      ],
      tableLabelRight: [],
      searchData: {
        supplierOrderId: null,
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      firstTime: true, //只有第一次调用
    };
  },
  methods: {
    handleClearAll() {
      this.addSelectData = [];
    },
    //页面操作  全选或者全不选
    handleSelectAll(val) {
      console.log(val, 'val');
      if (this.selectData.length === 0) {
        this.selectData = JSON.parse(JSON.stringify(val));
      } else {
        const rightIdArr = this.addSelectData.map((item) => item.orderNo); //右侧添加的数据
        const selectIdArr = this.selectData.map((item) => item.orderNo); //选中的数据

        this.tableData.forEach((item) => {
          if (!rightIdArr.includes(item.orderNo)) {
            //右侧没有
            if (selectIdArr.includes(item.orderNo)) {
              //在选中的数据中，剔除
              const indexNum = this.selectData.findIndex(
                (selectDataItem) => selectDataItem.orderNo === item.orderNo
              );
              this.selectData.splice(indexNum, 1);
            } else {
              //没在选中得数据中，添加
              this.selectData.push({ ...item });
            }
          }
        });
      }
    },
    //操作当前 一条
    handleSelect(val) {
      const { row, rows } = val;

      if (this.selectData.length > 0) {
        const whetherExist = rows.filter(
          (item) => item.orderNo === row.orderNo
        );

        if (whetherExist.length > 0) {
          //不存在
          this.selectData.push({ ...row });
        } else {
          const indexNum = this.ecPurchasePlanIdList.findIndex(
            (idListItem) => idListItem === row.orderNo
          );
          const selectDataIndexNum = this.selectData.findIndex(
            (item) => item.orderNo === row.orderNo
          );
          this.ecPurchasePlanIdList.splice(indexNum, 1);
          this.selectData.splice(selectDataIndexNum, 1);
        }
      } else {
        this.selectData.push({ ...row });
      }

      // console.log(this.selectData,'一条1111111111111')
    },
    checkboxSelect(row) {
      let indexNum = this.addSelectData.findIndex(
        (item) => item.orderNo === row.orderNo
      );

      if (indexNum === -1) {
        return true;
      } else {
        return false;
      }
    },
    handleConfirm() {
      this.$emit('confirmRelateNo', this.addSelectData);
      this.handleCancle();
    },
    handleCancle() {
      this.$emit('update:relateNoVisible', false);
    },
    handleAddData() {
      console.log(this.selectData, 'this.selectData');
      this.addSelectData = JSON.parse(JSON.stringify(this.selectData));
    },
    handleDel(index, item) {
      this.addSelectData.splice(index, 1);
    },
    handleCurrentChange(val) {
      this.searchData.pageNum = val;
      this.purchaseListOrder();
    },
    handleFilter(val) {
      this.searchData = { ...this.searchData, ...val, pageNum: 1 };
      const { submitTime } = val;

      if (submitTime && submitTime.length > 0) {
        this.searchData.startTime = submitTime[0];
        this.searchData.endTime = submitTime[1];
      } else {
        this.searchData.startTime = null;
        this.searchData.endTime = null;
      }

      this.purchaseListOrder();
    },
    handleReset() {
      this.searchData = {
        supplierOrderId: this.relateNoData.orderId,
        pageNum: 1,
        pageSize: 10,
        total: 0,
      };
      this.purchaseListOrder();
    },

    handleClose() {
      this.$emit('update:relateNoVisible', false);
    },
    //历史库存单-列表
    async purchaseListOrder() {
      const res = await api.purchaseListOrder(this.searchData);
      if (res.code === '200') {
        this.tableData = res.data.records || [];
        this.searchData.total = res.data.total || 0;

        this.$nextTick(() => {
          this.tableData.forEach((item) => {
            if (this.ecPurchasePlanIdList.includes(item.orderNo)) {
              this.$refs.multipleTable.$refs.table.toggleRowSelection(
                item,
                true
              );
            }
          });
        });
      }
    },
    async queryOrderManageBind() {
      let res = await api.queryOrderManageBind({
        supplierOrderId: this.relateNoData.orderId,
      });
      if (res.code === '200') {
        const data = res.data;
        this.addSelectData = JSON.parse(JSON.stringify(data));
        this.selectData = JSON.parse(JSON.stringify(data));
        this.ecPurchasePlanIdList = data.map((item) => item.orderNo);
      }
    },
    formatOrderSource(val) {
      let res = '';
      switch (val) {
        case 1:
          res = '普通订单';
          break;
        case 2:
          res = '普通订单';
          break;
        case 3:
          res = '一体化订单';
          break;
        case 4:
          res = '询比价订单';
          break;
        case 5:
          res = '融合集成订单';
          break;
        case 6:
          res = '普通订单';
          break;
        case 9:
          res = '招标订单';
          break;
        case 10:
          res = '非标订单';
          break;
        case 31:
          res = '融合集成订单';
          break;
      }
      return res;
    },
  },
  async mounted() {
    this.searchData.supplierOrderId = this.relateNoData.orderId;
    await this.queryOrderManageBind();
    this.purchaseListOrder();
  },
};
</script>

<style scoped lang="scss">
.content-wrapper {
  height: 100%;
  padding: 16px 20px;

  .table-wrapper {
    width: 100%;

    .add-box {
      margin: 0 10px;
    }

    .tip-title {
      color: #333;
      font-size: 14px;
      font-family: SourceHanSansCN-Medium;
    }

    .right-table {
      .table-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 44px;
        border: 1px solid #ebeef5;
        border-bottom: none;
        padding: 0 10px;
        background-color: #f5f5f5;
      }
    }
  }
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: right;
  background: var(--w-0-ffffff, #fff);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  height: 70px;
  line-height: 70px;
}

::v-deep .el-drawer__header {
  height: 40px;
  line-height: 40px;
  background-color: #f5f5f5;
  margin-bottom: 0;
  padding: 16px 20px 0 20px;

  span,
  .el-drawer__close-btn {
    margin-bottom: 20px;
    color: #333;
  }
}

::v-deep .el-table .el-table__cell {
  padding: 9.5px 0;
}
</style>
